import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconArrowRight, IconSupport } from '@redteclab/icons'

import { Button } from 'base-ui'

import { DirectContactTelephoneDialog } from '../../../direct-contact'
import { useOpenableControls } from '../../../generic-hooks'
import { useGlobalConfigContext } from '../../../global-config'
import { TENANT } from '../../../tenant'
import { ContactPageDirectContactSectionTelephoneDialog } from '../ContactPageDirectContactSectionTelephoneDialog'

export const ContactPagePhoneLabel: FC<{ onSuccess: () => void }> = ({
  onSuccess,
}) => {
  const modalControlsTelephoneDialog = useOpenableControls()
  const { tenant } = useGlobalConfigContext()

  return (
    <>
      <Button
        className="w-full"
        endIcon={<IconArrowRight className="fill-dark-brand" />}
        id="contact.page.telephone.label"
        key="contact.page.telephone.label"
        onClick={() => {
          modalControlsTelephoneDialog.handleOpen()
        }}
        size="large"
        startIcon={<IconSupport className="fill-dark-brand" />}
        variant="text"
      >
        <span className="grow text-start">
          <FormattedMessage id="contact.directContactSection.firstCard.title" />
        </span>
      </Button>
      {tenant === TENANT.COM ? (
        <DirectContactTelephoneDialog
          modalControls={modalControlsTelephoneDialog}
          onCustomerSupportUnavailableFormSubmittedWithSuccess={onSuccess}
        />
      ) : (
        <ContactPageDirectContactSectionTelephoneDialog
          modalControls={modalControlsTelephoneDialog}
        />
      )}
    </>
  )
}
